"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FocusToggleStyles = void 0;
var _core = require("@emotion/core");
var _react = _interopRequireDefault(require("react"));
var _focusRing = require("../../../util/focusRing");
var _useFocusEventListener = require("../hooks/useFocusEventListener");
var _useFocusMode = require("../hooks/useFocusMode");
/**
 * The mouse event names to listen for to turn focus styles off.
 */
const mouseEvents = new Set(["mousedown"]);

/**
 * The keyboard event names to listen for to turn focus styles on.
 */
const keyEvents = new Set(["keydown"]);

/**
 * The key event codes to listen for to turn focus styles on.
 */
const keyCodes = new Set(["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft", "Tab", "PageUp", "PageDown"]);
const FocusToggleStyles = () => {
  // Turn on/off the focus marker.
  const {
    focusMode,
    setFocusMode
  } = (0, _useFocusMode.useFocusMode)();
  (0, _useFocusEventListener.useFocusEventListener)({
    focusMode,
    mouseEvents,
    keyEvents,
    keyCodes,
    setFocusMode
  });
  return /*#__PURE__*/_react.default.createElement(_core.Global, {
    styles: {
      // This style will hide all before elements with the FOCUS_ELEMENT_CLASS_NAME applied to them.
      // Most focus styles are applied as ::before elements in lodestar-core.
      [`body:not(.${_useFocusMode.SHOW_FOCUS_MARKER}) .${_focusRing.FOCUS_USING_BEFORE_CLASS_NAME}::before`]: {
        display: "none"
      },
      // This style will hide the actual element (as opposed to the pseudoelement ::before) with the className
      // Most focus styles are applied as ::before elements in lodestar-core, but some need to be regular elements (like Tabs).
      [`body:not(.${_useFocusMode.SHOW_FOCUS_MARKER}) .${_focusRing.FOCUS_USING_ELEMENT_CLASS_NAME}`]: {
        display: "none"
      }
    }
  });
};
exports.FocusToggleStyles = FocusToggleStyles;
//# sourceMappingURL=FocusToggleStyles.js.map